export const SHOW_ACADEMY = false;
export const SHOW_JOBS = true;
